import { render, staticRenderFns } from "./profit_transfer_item_list.vue?vue&type=template&id=f752a2da&scoped=true"
import script from "./profit_transfer_item_list.vue?vue&type=script&lang=js"
export * from "./profit_transfer_item_list.vue?vue&type=script&lang=js"
import style0 from "./profit_transfer_item_list.vue?vue&type=style&index=0&id=f752a2da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f752a2da",
  null
  
)

export default component.exports